$(document).on("click", function (e) {
  const target = $(e.target);
  if (target.closest("quick-view-modal .drawer__close-btn").length) {
    const isAnyOpen = $("quick-view-modal[open]").length > 0;
    const searchInput = $("#SearchDrawer .search__input");

    if ($("#SearchDrawer[open]").length > 0) {
      setTimeout(() => {
        searchInput.trigger("click");
      }, 600);
    }
  }
});

function bindTopProductsSliders(root = document) {
  if (!(root instanceof Element || root instanceof Document)) {
    return;
  }
  root
    .querySelectorAll(".wizzy-autocomplete-top-products")
    .forEach((wrapper) => {
      // Avoid double-binding
      if (wrapper.__wzBound) return;
      wrapper.__wzBound = true;

      const list = wrapper.querySelector("ul.autocomplete-top-products");
      const prevBtn = wrapper.querySelector("#wz-left-scroll");
      const nextBtn = wrapper.querySelector("#wz-right-scroll");
      if (!list || !prevBtn || !nextBtn) return;

      // Ensure the list is actually scrollable
      list.style.scrollBehavior = "smooth";

      const step = () => Math.max(list.clientWidth * 0.9, 200);

      const updateBtns = () => {
        const max = list.scrollWidth - list.clientWidth - 1;
        prevBtn.classList.toggle("is-disabled", list.scrollLeft <= 0);
        nextBtn.classList.toggle("is-disabled", list.scrollLeft >= max);
      };

      prevBtn.addEventListener("click", () => {
        list.scrollTo({
          left: Math.max(0, list.scrollLeft - step()),
          behavior: "smooth",
        });
      });

      nextBtn.addEventListener("click", () => {
        list.scrollTo({
          left: Math.min(list.scrollWidth, list.scrollLeft + step()),
          behavior: "smooth",
        });
      });

      list.addEventListener("scroll", updateBtns);
      window.addEventListener("resize", updateBtns);
      updateBtns();
    });
}

function blurAndFocusOnInput() {
  const input = document.querySelector(".wizzy-search-input");
  const autocompleteWrapper = document.querySelector(
    ".wizzy-autocomplete-wrapper"
  );

  if (input && autocompleteWrapper) {
    top = window.scrollY == 0 ? "120px" : "80px";
    autocompleteWrapper.style.top = top;
  }
}

let hasScrolledBottomOnce = false;

if (window.innerWidth > 768) {
  window.addEventListener("scroll", () => {
    if (window.scrollY === 0) {
      hasScrolledBottomOnce = false;
      blurAndFocusOnInput();
    } else {
      if (hasScrolledBottomOnce === false) {
        blurAndFocusOnInput();
        hasScrolledBottomOnce = true;
      }
    }
  });
}

if (window.innerWidth < 768) {
  $("body").on(
    "click",
    ".wz-recent-text, .wz-trending-search-text",
    function (e) {
      e.preventDefault();
      $(this).parent()[0].click();
    }
  );
}
// Run after DOM is ready
document.addEventListener("DOMContentLoaded", bindTopProductsSliders);

// Re-bind when Wizzy injects the template
new MutationObserver(() => bindTopProductsSliders()).observe(document.body, {
  childList: true,
  subtree: true,
});

// Wizzy may inject after load — observe and (re)bind
new MutationObserver((muts) => {
  const added = muts.some((m) =>
    [...m.addedNodes].some(
      (n) => n.nodeType === 1 && n.matches?.(".wizzy-autocomplete-top-products")
    )
  );
  if (added) initTopProductsSliders();
}).observe(document.body, { childList: true, subtree: true });

const searchBtn = document.querySelector(
  ".header__buttons .search-drawer-button"
);
const searchInput = document.querySelector("#SearchDrawer .search__input");

if (searchBtn && searchInput) {
  searchBtn.addEventListener("click", () => {
    setTimeout(() => {
      searchInput.click();
      
      const cartCloseBtn = document.querySelector(".yt-cart-drawer .close-button");
      if(cartCloseBtn) {
        cartCloseBtn.addEventListener("click", function(e) {
          const searchDrawer = document.querySelector("#SearchDrawer");
          if(searchDrawer && searchDrawer.hasAttribute("open")) {
            setTimeout(()=>{
              searchInput.click();
            },600);
          }
        });
      }

      // const searchInput = document.querySelector("#SearchDrawer .search__input");
          // const autoCompletequickViewCloseBtns = document.querySelectorAll(".topproduct-item quick-view-modal .drawer__close-btn");
          // if(autoCompletequickViewCloseBtns) {
          //   autoCompletequickViewCloseBtns.forEach(quickViewCloseBtn => {
          //     quickViewCloseBtn.addEventListener("click", function(e) {
          //       const quickViewDrawer = document.querySelectorAll("quick-view-modal");
          //       const isAnyOpen = Array.from(quickViewDrawer).some(el => el.hasAttribute("open"));
          //       if(isAnyOpen) {
          //         setTimeout(()=>{
          //           searchInput.click();
          //         },600);
          //       }
          //     });
          //   });
          // }
    }, 600);
  });
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      data.store.symbol = "Rs.";
      if (window.innerWidth < 768) {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: ".search__input",
          type: "search",
        };
      }
      window.wizzyConfig.common.isOnCategoryPage == true
        ? (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "#wizzy-shopify-collection-page-wrapper",
          ])
        : (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "body main",
          ]);
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      data.store.symbol = "Rs.";
      data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: ".search__input",
        type: "search",
      };
      window.wizzyConfig.common.isOnCategoryPage == true
        ? (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "#wizzy-shopify-collection-page-wrapper",
          ])
        : (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "body main",
          ]);
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER,
    function (data) {
      data.topProductsTitle = "Search Results";
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers[0] =
        "body main";
        
      const searchDrawer = document.querySelector("#SearchDrawer");
      if(searchDrawer) {
        if(searchDrawer.hasAttribute("open")){
          searchDrawer.removeAttribute("open");
        }
        if(searchDrawer.hasAttribute("active")){
          searchDrawer.removeAttribute("active");
        }
      }

      const collectionBanner = document.querySelector(
        "#shopify-section-template--25561033113875__banner"
      );
      const collectionCustomContent = document.querySelector(
        "#shopify-section-template--25295362556179__custom_content_RecVe9"
      );
      if (collectionBanner) {
        collectionBanner.style.display = "none";
      }
      if (collectionCustomContent) {
        collectionCustomContent.style.display = "none";
      }
      
      const searchInput = document.querySelector("#SearchDrawer .search__input");
      if(searchInput) {
        searchInput.value = '';
      }


      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      payload.filters.showOOSProductsInOrder = "true";
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      data.forEach((product) => {
        // Remove decimal part from prices
        if (
          typeof product.price !== "undefined" &&
          product.price &&
          product.price.toString().includes(".")
        ) {
          product.price = product.price.toString().split(".")[0];
        }

        if (
          typeof product.sellingPrice !== "undefined" &&
          product.sellingPrice &&
          product.sellingPrice.toString().includes(".")
        ) {
          product.sellingPrice = product.sellingPrice.toString().split(".")[0];
        }

        product.hasVariantPrice = false;
        if (product.attributes) {
          product.attributes.forEach((attr) => {
            if (attr.id === "product_card_secondary_des_custom") {
              product.secondaryDesCustom = attr.values[0].value[0];
            }
            if (attr.id === "product_badge_judgeme") {
              // product.judgemeReview = attr.values[0].value[0];
              product.badge_judgeme = attr.values[0].value[0];
              const htmlString = attr.values[0].value[0],
                tempElement = document.createElement("div");
              tempElement.innerHTML = htmlString;
              const dataScore = tempElement
                .querySelector(".jdgm-prev-badge__stars")
                .getAttribute("data-score");
              const dataReview = tempElement
                .querySelector(".jdgm-prev-badge")
                .getAttribute("data-number-of-reviews");
              product.totalRatings = dataScore;
              product.totalReview = dataReview;
            }
          });
        }
      });

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      if (
        data.data.api === "filter" &&
        window.wizzyConfig.common.isOnCategoryPage
      ) {
        const collectionProductCount =
          window.innerWidth < 768
            ? document.querySelector(".wizzy-search-summary-container")
            : document.querySelector(".wizzy-collection-product-count");
        if (collectionProductCount) {
          collectionProductCount.innerHTML =
            data.data.response.payload.total + " Products";
        }

        const selectedFilters = document.querySelector(
          ".wizzy-selected-filters"
        );
        const searchFiltersTop = document.querySelector(
          ".wizzy-search-filters-top"
        );
        if (selectedFilters && searchFiltersTop) {
          searchFiltersTop.insertAdjacentElement("afterend", selectedFilters);
        }
      }

      if (
        data.data.api === "autocomplete" || (data.data.api === "filter" && data.data.response.payload.filters.type === "AUTOCOMPLETE_DEFAULT") || data.data.api === "trendingSearch"
      ){
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {
      if (data.api == "search" || data.api == "filter") {
        data.response?.payload?.facets?.forEach((facet) => {
          if (facet.data && Array.isArray(facet.data)) {
            facet.data.forEach((item) => {
              if (item.label) {
                item.label = item.label
                  .toLowerCase()
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ");
              }
            });
          }
        });
      }

      if (data.api === "autocomplete") {
        if (data.response?.payload?.others) {
          data.response.payload.others = data.response?.payload?.others.slice(
            0,
            3
          );
        }
      }

      return data;
    }
  );
};
